import CreateDynamicFormRequestModelBase from '../_generated/modelBases/create-dynamic-form-request-model-base';

export default class CreateDynamicFormRequestModel extends CreateDynamicFormRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
